import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ClerkProvider } from '@clerk/clerk-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { GlobalLoadingProvider } from './providers/global-loading-provider'
import { PostHogProvider } from './components/providers/posthog-provider'
import { RoleProvider } from './contexts/role-context'
import { ApiClientProvider } from './components/providers/api-client-provider'
import { WebSocketProvider } from './contexts/WebSocketContext'
import App from './App.tsx'
import './globals.css'

const queryClient = new QueryClient()

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key")
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ApiClientProvider>
            <WebSocketProvider>
              <RoleProvider>
                <PostHogProvider>
                  <GlobalLoadingProvider>
                    <App />
                  </GlobalLoadingProvider>
                </PostHogProvider>
              </RoleProvider>
            </WebSocketProvider>
          </ApiClientProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>,
)